import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { appMenuItemDefinitions } from './menuItems';
import { AppMenuItem } from './types';

/**
 * Custom hook for managing app menu state
 */
export const useAppMenuState = () => {
  const auth = useAuth();
  const [userIsAuthenticated, setUserIsAuthenticated] = useState(false);
  const [appMenuItems, setAppMenuItems] = useState<Array<AppMenuItem>>([]);

  useEffect(() => {
    // Only show non-admin items in the main menu
    setAppMenuItems(appMenuItemDefinitions.filter((x) => x.RequireAdmin === false));
  }, [userIsAuthenticated]);

  useEffect(() => {
    const isAuthenticated = auth !== null && auth !== undefined && auth.isAuthenticated;
    console.info(`AppMenu: auth was updated. User is ${isAuthenticated ? '' : 'not'} authenticated.`);
    console.info(`New user state: ${JSON.stringify(auth)}`);
    setUserIsAuthenticated(isAuthenticated);
  }, [auth]);

  // Get admin menu items
  const adminMenuItems = appMenuItemDefinitions.filter((x) => x.RequireAdmin === true);

  return {
    userIsAuthenticated,
    appMenuItems,
    adminMenuItems,
  };
};
